const appLayoutStrings = {
  pageTitle: "@commonStrings.appName",
  toolbarTitle: "@:commonStrings.appName",
  errorAlert: "En feil oppsto: ",
  skipToContentLink: "Gå til innhold"
};

export default appLayoutStrings;